import React, { useMemo } from 'react';
import './ScrollableViewport.scss';
export const ScrollableViewport = ({ children, vertical = false, horizontal = false, }) => {
    const className = useMemo(() => {
        const list = ['scrollable-viewport'];
        if (vertical)
            list.push('scrollable-viewport--vertical');
        if (horizontal)
            list.push('scrollable-viewport--horizontal');
        return list.join(' ');
    }, [horizontal, vertical]);
    return React.createElement("div", { className: className }, children);
};
//# sourceMappingURL=ScrollableViewport.js.map